import {
	triggerUserClickedEmptySavedSearchPillEvent,
	triggerUserDisabledSavedSearchEvent,
	triggerUserHoveredActivePillEvent,
	triggerUserHoveredEmptyPillEvent,
} from 'Services/analytics/events';

export const triggerSavedSearchPillClickGAEvent = (hasActiveSavedSearch: boolean): void => {
	if (hasActiveSavedSearch) {
		triggerUserDisabledSavedSearchEvent();
	} else {
		triggerUserClickedEmptySavedSearchPillEvent();
	}
};

export const triggerSavedSearchPillHoverGAEvent = (hasActiveSavedSearch: boolean): void => {
	if (hasActiveSavedSearch) {
		triggerUserHoveredActivePillEvent();
	} else {
		triggerUserHoveredEmptyPillEvent();
	}
};
